import { createContext, useContext, ReactNode, useState, useEffect } from "react";

interface ChunkErrorContextType {
    hasChunkError: boolean;
    reloadPage: () => void;
}

const ChunkErrorContext = createContext<ChunkErrorContextType | undefined>(undefined);

export function ChunkErrorProvider({ children }: { children: ReactNode }) {
    const [hasChunkError, setHasChunkError] = useState(() => {
        const chunkError = localStorage.getItem('chunk-error');
        return chunkError === 'true';
    });

    useEffect(() => {
        const handleChunkError = () => {
            setHasChunkError(true);
        };
        window.addEventListener('chunk-error-detected', handleChunkError);
        return () => {
            window.removeEventListener('chunk-error-detected', handleChunkError);
        };
    }, []);
    const reloadPage = () => {
        localStorage.removeItem('chunk-error');
        window.location.reload();
    };

    return (
        <ChunkErrorContext.Provider value={{ hasChunkError, reloadPage }}>
            {children}
        </ChunkErrorContext.Provider>
    );
}

export function useChunkError() {
    const context = useContext(ChunkErrorContext);
    if (!context) {
        throw new Error("useChunkError must be used within ChunkErrorProvider");
    }
    return context;
}